<template>
  <div class="appeal-card" @click="openAppeal('update', appeal)">
    <v-badge
      v-if="appeal.chat?.objectId && appeal.chat.marketUnreadCount > 0"
      color="error"
      :content="appeal.chat.marketUnreadCount"
      inline
      class="appeal-card-badge"
      >
    </v-badge>
    <div class="appeal-card-header">
      <div class="appeal-card-header-title">
        <div class="dot-status" :class="`dot-status-${status}`"></div> 
        <div class="appeal-card-header-title-text">
          {{ appeal.subCategory && AppealLabels.subCategory[appeal.subCategory] 
            ? ($t(`appeal_data.subCategory.${AppealLabels.subCategory[appeal.subCategory].value}`)) 
            : '' 
          }}
        </div>
      </div>
    </div>
    <div class="appeal-card-body">
      <div class="appeal-card-body-title">
        <div class="appeal-name">
          <template v-if="appeal.customerType && appeal.customerType == 'central'">
            {{ $t('appeal.central') }}
          </template>
          <template v-else>
            {{ appeal.customer && appeal.customer.type == 'company' ? `${$t('company')} ` + (appeal.customer.companyName || '-') :
            fullName(appeal.customer) }}
          </template>
        </div>
        <div class="appeal-area">
          <template
            v-if="appeal.subCategory != 'change_info_contact' && appeal.subCategory != 'document_shop_certify' && appeal.areas.length">
            {{ $t('area.stall_at') }}
            <template v-for="(slotLock, indexIn) in appeal.areas">
              {{ slotLock.name }} {{ indexIn != appeal.areas.length - 1 ? ',' : '' }}
            </template>
          </template>
        </div>
      </div>
      <div v-if="appeal.description" class="appeal-card-body-content">
          {{ appeal.description }}
      </div>
      <div v-if="appeal.statusApprovedBy" class="appeal-approve-by">
        <b>{{ $t('task.approve_bill_user') }}:</b> {{ fullName(appeal.statusApprovedBy) }}
      </div>
      <div class="appeal-card-body-footer"> 
        <div class="appeal-card-body-footer-date">
          {{ momentToDate(appeal.createdAt, 'date') }}
        </div>
        <div class="appeal-card-body-footer-message">
          <div class="d-flex align-center">   
            <img
              src="@/assets/icons/message.svg"
              style="width: 20px; height: 20px; vertical-align: middle; margin-right: 5px;"
            >
            <template v-if="appeal.chat && appeal.chat.messageCount > 0">
              {{ appeal.chat.messageCount }} {{ $t('message') }}
            </template>
            <template v-else>
              {{ $t('no_message') }}
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppealLabels from "../json/appeal-data.json";
import { mapGetters } from "vuex";
export default {
  name: 'AppealCard',
  props: {
    appeal: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      AppealLabels
    }
  },
  methods: {
    fullName(customer) {
      let fullname = "";
      if (customer) {
        fullname = `${customer.title || ""} ${customer.firstName ||
          "-"} ${customer.lastName || "-"}`;
      }
      if (!fullname) fullname = this.$t('not_specified');
      return fullname;
    },
    openAppeal(mode, appeal) {
      this.$emit('openAppeal', mode, appeal);
    },
    momentToDate(date, format = "datetime") {
      let res = "";
      let formatDate = "DD MMM YYYY, HH:mm " + this.$t('timeunit.minute.short');
      if (format == "date") formatDate = "DD MMM YYYY";
      if (format == "datetimesec") formatDate = "DD MMM YYYY, HH:mm:ss";
      if (date?.iso) res = this.$moment(date.iso).format(formatDate);
      else if (date) res = this.$moment(date).format(formatDate);
      else res = "-";
      return res;
    },
  }
}
</script>

<style scoped lang="scss">
.appeal-card{
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
  user-select: none;
  .appeal-card-badge{
    position: absolute;
    top: -7px;
    right: -9px;
  }
  .appeal-card-header{
    .appeal-card-header-title{
      display: flex;
      align-items: center;
      gap: 10px;
      overflow: hidden;
      border-bottom: 1px solid #E4E6E8;
      padding: 8px 10px 5px 10px;
      .appeal-card-header-title-text{
        font-size: 17px;
        font-weight: 500;
        text-overflow: ellipsis;
      }
      .dot-status{
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
      .dot-status-pending{
        background-color: var(--v-warning-base);
      }
      .dot-status-waiting{
        background-color: var(--v-info-base);
      }
      .dot-status-approved{
        background-color: var(--v-accent-base);
      }
      .dot-status-success{
        background-color: var(--v-success-base);
      }
      .dot-status-cancelled{
        background-color: var(--v-error-base);
      }
    }
  }
  .appeal-card-body{
    padding: 10px 10px 5px 10px;
    .appeal-card-body-title{
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 15px;
      // margin-bottom: 5px;
      .appeal-name{
        max-width: 50%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .appeal-area{
        max-width: 70%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .appeal-card-body-content{
      font-size: 14px;
      font-weight: 300;
      color: #A8A8A8;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      // margin-bottom: 5px;
    }
    .appeal-card-body-footer{
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #A8A8A8;
      .appeal-card-body-footer-message{
        display: flex;
        align-items: center;
        gap: 10px;
        color: #A8A8A8;
      }
    }
    .appeal-approve-by{
      font-size: 14px;
      font-weight: 400;
      color: #A8A8A8;
      margin-top: 5px;
      border-top: 1px dashed #E4E6E8;
      padding-top: 5px;
    }
  }
}
</style>